import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import "../Common/css/styles.css";
import learning from "../Assets/Images/learning_materials.png";
import assignments from "../Assets/Images/assignments.png";
import recordings from "../Assets/Images/recordings.png";
import zoom from "../Assets/Images/zoom_meeting.png";
import addRecording from "../Assets/Images/add-video.png";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormLabel, IconButton, MenuItem, Modal, Select, Stack, TextField, Tooltip, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import "../Common/css/recordIcon.css";
import text from "../Assets/Text/Text.json";
import PrimaryInputField from 'src/Components/InputFields';
import { createRecording, deleteMeeting, deleteRecording, getCurrentMeeting, getRecording, setCurrentMeeting, setVisibile } from 'src/Services/zoom_api';
import { ZoomMeetingBody, zoomRecordingBody } from 'src/Interfaces/zoom';
import camera from "../Assets/Images/video-camera.png";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Dialogbox from 'src/Components/Dialogbox';
import CustomAlert from 'src/Components/Alerts';
import dayjs from 'dayjs';
import { Close, FilePresent, Upload, Visibility } from '@mui/icons-material';
import { CloseCircleFilled, OrderedListOutlined } from '@ant-design/icons';
import { addMaterial, addMaterialFilePath, deleteMaterial, deleteMaterialFilePath, getMaterial, getMaterialPaths } from 'src/Services/materials_api';
import Spinner from 'src/Components/Spinner';
import { addAssignment, addAssignmentFilePath, deleteAssignment, deleteAssignmentFilePath, getAssignment, getAssignmentPaths, updateUploadStatus } from 'src/Services/assignments_api';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { getAttendanceListBySubject, getSubjectId, updateAttendance } from 'src/Services/attendance_api';

export const InstructorSubject = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { course } = location.state || {};

    const [loading, setLoading] = useState(false);
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertDescription, setAlertDescription] = useState("");
    const [alertType, setAlertType] = useState<"success" | "error" | "warning">("success")

    const [isExpanded, setIsExpanded] = useState(false);
    const [isExpanded1, setIsExpanded1] = useState(false);
    const [isExpanded2, setIsExpanded2] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [openRecordingDialog, setOpenRecordingDialog] = useState(false);
    const [isOpenA, setIsOpenA] = useState(false);
    const [isOpenA1, setIsOpenA1] = useState(false);
    const [isOpenA2, setIsOpenA2] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpen1, setIsOpen1] = useState(false);
    const [isOpen2, setIsOpen2] = useState(false);
    const [isOpenEnd, setIsOpenEnd] = useState(false);
    const [isOpenAttendance, setIsOpenAttendance] = useState(false);
    const [matDialog, setMatDialog] = useState(false)

    const [inviteLink, setInviteLink] = useState("");
    const [duration, setDuration] = useState<number>()
    const [recordingTitle, setRecordingTitle] = useState("");
    const [recordingLink, setRecordingLink] = useState("");
    const [recordingId, setRecordingId] = useState(0);

    const [resLink, setResLink] = useState(false)
    const [resInsId, setResInsId] = useState(false)

    const [recordingsLinks, setRecordingsLinks] = useState<any[]>([])
    const [addAssignmentFolderModalOpen, setAddAssignmentFolderModalOpen] = useState(false);
    const [addFolderModalOpen, setAddFolderModalOpen] = useState(false);
    const [selectedFolderPath, setSelectedFolderPath] = useState("");
    const [selectedAssignmentFolderPath, setSelectedAssignmentFolderPath] = useState("");
    const [newAssignmentFolderName, setNewAssignmentFolderName] = useState("");
    const [newFolderName, setNewFolderName] = useState("");
    const [materialPaths, setMaterialPaths] = useState<any[]>([])
    const [assignmentPaths, setAssignmentPaths] = useState<any[]>([])

    const [uploadAssignmentModalOpen, setUploadAssignmentModalOpen] = useState(false);
    const [uploadAssignmentFolderId, setUploadAssignmentFolderId] = useState<any>();
    const [uploadModalOpen, setUploadModalOpen] = useState(false);
    const [uploadFolderId, setUploadFolderId] = useState<any>();
    const [dragActive, setDragActive] = useState(false);
    const [selectedFile, setSelectedFile] = useState<any>(null);
    const [selectedAssignmentFile, setSelectedAssignmentFile] = useState<any>(null);
    const [pdfUrl, setPdfUrl] = useState<string | null>(null);
    const [pdfUrlA, setPdfUrlA] = useState<string | null>(null);

    const token = sessionStorage.getItem("token") || "";
    const instructorcourse = sessionStorage.getItem("instructor-course") || "";
    const programme = sessionStorage.getItem("instructor-programme") || "";
    const instructorId = sessionStorage.getItem("insId") || "";

    const [expandedAssignmentPaths, setAssignmentExpandedPaths] = useState<Set<string>>(new Set());
    const [expandedPaths, setExpandedPaths] = useState<Set<string>>(new Set());

    const [uploadStatusVisibility, setUploadStatusVisibility] = useState(false)
    const [uploadStatusVisibility2, setUploadStatusVisibility2] = useState(false)
    const [startDate, setStartDate] = useState<Date | null>(new Date());
    const [endDate, setEndDate] = useState<Date | null>(new Date());
    const [startDate2, setStartDate2] = useState<Date | null>(new Date());
    const [endDate2, setEndDate2] = useState<Date | null>(new Date());
    const [attempts, setAttempts] = useState(0)
    const [attempts2, setAttempts2] = useState(0)
    const [attendanceList, setAttendanceList] = useState<any[]>([]);
    const [searchText, setSearchText] = useState("");

    const handleAttendanceChange = (userId: number, value: boolean) => {
        setAttendanceList((prev) =>
            prev.map((item) =>
                item.userId === userId ? { ...item, isAttend: value } : item
            )
        );
    };

    const [subjectId, setSubjectId] = useState<string>("");

    const handleGetAttendanceList = async () => {
        try {
            const res = await getAttendanceListBySubject(token, subjectId);
            setAttendanceList(res);
        } catch (error) {
            setAttendanceList([]);
        }
    }

    const userId = sessionStorage.getItem("userId") || "";

    const handleMarkAttendance = async (record: any, isPresent: boolean) => {

        try {
            await updateAttendance(token, record.userId, subjectId, new Date().toISOString(), isPresent);

        } catch (error) {
            console.error(error);
        }
    }

    const showAlert = (description: string, type: "success" | "error" | "warning") => {
        setAlertDescription(description);
        setAlertType(type);
        setAlertOpen(true);
    };

    const handleGetSubjectId = async () => {
        try {
            const res = await getSubjectId(token, programme, instructorcourse.split(" :")[0], instructorcourse.split(": ")[1] === instructorcourse.split(" :")[0] ? "" : instructorcourse.split(": ")[1]);
            setSubjectId(res.id);
        } catch (error) {
            console.error("Error fetching subject ID:", error);
        }
    }

    useEffect(() => {
        handleGetSubjectId();
    }, []);

    const handleOpenRecordingDialog = () => {
        setOpenRecordingDialog(true);
    }

    const handleCloseRecordingDialog = () => {
        setRecordingTitle("");
        setRecordingLink("");
        setOpenRecordingDialog(false);
    }

    const handleCloseDialog = () => {
        setInviteLink("")
        setDuration(undefined)
        setOpenDialog(false);
    };

    const streamTitleRef = useRef<HTMLSpanElement>(null);

    useEffect(() => {
        if (!course) {
            navigate("/");
        } else {
            window.scrollTo(0, 0);
        }

        console.log(course);


        handleGetRecordings();
        handleGetCurrentSession()
        handleGetMaterialPaths()
        handleGetAssignmentPaths()
    }, [course, navigate]);

    const handleGetCurrentSession = async () => {
        console.log(instructorcourse);

        try {
            const res = await getCurrentMeeting(programme, instructorcourse.split(" :")[0], instructorcourse.split(": ")[1] === instructorcourse.split(" :")[0] ? null : instructorcourse.split(": ")[1], token);
            if (res.data.instructorId === Number(instructorId)) {
                setResInsId(true)
            } else {
                setResInsId(false)
            }

            if (res.data.zoomMeetingLink === null) {
                setResLink(true)
                setResInsId(false)
            } else {
                setResLink(false)
            }
        } catch (error) {
            console.error("Error fetching meetings:", error);
        }
    }

    const handleGetRecordings = async () => {
        try {
            const res = await getRecording(programme, instructorcourse.split(" :")[0], instructorcourse.split(": ")[1] === instructorcourse.split(" :")[0] ? "" : instructorcourse.split(": ")[1], token);
            setRecordingsLinks(res.data)
        } catch (error) {
            console.error("Error fetching recordings:", error);
        }
    }


    const toggleExpand = () => setIsExpanded(!isExpanded);
    const toggleExpand1 = () => setIsExpanded1(!isExpanded1);
    const toggleExpand2 = () => setIsExpanded2(!isExpanded2);

    const handleAddClickAssignment = (folderPath: string) => {
        setSelectedAssignmentFolderPath(folderPath);
        setAddAssignmentFolderModalOpen(true);
    };

    const handleAddClick = (folderPath: string) => {
        setSelectedFolderPath(folderPath);
        setAddFolderModalOpen(true);
    };

    const handleSaveInvitiation = async () => {

        const now = dayjs();
        if (duration === undefined) {
            console.error("Duration is required");
            return;
        }

        const end = now.add(duration, 'hour');;

        const format = 'YYYY-MM-DD HH:mm:ss.SSSSSS';
        const startTime = now.format();
        const endTime = end.format();

        const body: ZoomMeetingBody = {
            programme,
            stream: instructorcourse.split(" :")[0],
            subject: instructorcourse.split(" :")[0] === instructorcourse.split(": ")[1] ? null : instructorcourse.split(": ")[1],
            zoomMeetingLink: inviteLink,
            startTime,
            endTime,
            started: true,
            createdBy: instructorId.toString()
        }
        try {
            await setCurrentMeeting(body, token)
            showAlert("Zoom Invitation Sharing", "success")
            handleGetCurrentSession()
        } catch (error) {
            console.error(error);
        }

        handleCloseDialog()
    }

    const handleSaveRecording = async () => {
        // let programme = ""
        // if (course.split(" :")[0] === "Arts Stream" || course.split(" :")[0] === "Commerce Stream" || course.split(" :")[0] === "Technology Stream") {
        //     programme = "Fast track A/L";
        // } else if (course.split(" :")[0].startsWith("Diploma")) {
        //     programme = "Diploma";
        // } else {
        //     programme = "Certificate course";
        // }

        const body: zoomRecordingBody = {
            instructorId: Number(instructorId),
            recordLink: recordingLink,
            title: recordingTitle,
            programme: programme,
            stream: course.split(" :")[0],
            subject: course.split(": ")[1] === course.split(" :")[0] ? null : course.split(": ")[1],
        }
        try {
            const res = await createRecording(body, token);
            await handleGetRecordings();

        } catch (error) {
            console.error("Error creating recording:", error);
        }

        handleCloseRecordingDialog();
    }

    const handleDeleteRecording = async () => {
        try {
            await deleteRecording(programme, instructorcourse.split(" :")[0], instructorcourse.split(": ")[1] === instructorcourse.split(" :")[0] ? "" : instructorcourse.split(": ")[1], recordingId.toString(), instructorId, token);
            await handleGetRecordings();
        } catch (error: any) {
            if (error.response.data.message === "Instructor is not assigned to this Programme (Parameter 'recording')") {
                showAlert("You do not have permission to delete this recording.", "error")
            }
        }
    }

    const handleDeleteMeeting = async () => {
        try {
            await deleteMeeting(programme, instructorcourse.split(" :")[0], instructorcourse.split(": ")[1] === instructorcourse.split(" :")[0] ? "" : instructorcourse.split(": ")[1], recordingId.toString(), instructorId, token);
            await handleGetCurrentSession();
        } catch (error: any) {
            if (error.response.data.message === "Instructor is not assigned to this Programme (Parameter 'recording')") {
                showAlert("You do not have permission to delete this recording.", "error")
            }
        }
    }

    const handleOpen = (recordingId: number) => {
        setRecordingId(recordingId)
        setIsOpen(true);
    }

    const handleOpenEnd = (recordingId: number) => {
        setRecordingId(recordingId)
        setIsOpenEnd(true);
    }

    const handleClose = () => {
        setIsOpen(false);
    }

    const handleCloseA1 = () => {
        setIsOpenA1(false);
    }

    const handleCloseA2 = () => {
        setIsOpenA2(false);
    }

    const handleClose1 = () => {
        setIsOpen1(false);
    }

    const handleClose2 = () => {
        setIsOpen2(false);
    }

    const handleCloseEnd = () => {
        setIsOpenEnd(false);
    }

    const handleVisibility = async (status: boolean, recordingId: number) => {
        try {
            await setVisibile(programme, instructorcourse.split(" :")[0], instructorcourse.split(": ")[1] === instructorcourse.split(" :")[0] ? "" : instructorcourse.split(": ")[1], recordingId.toString(), instructorId, status, token)
            handleGetRecordings()
        } catch (error) {
            console.error(error);
        }
    }

    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleOpenDialog2 = () => {
        setIsOpenEnd(true);
    };

    const handleOpenAttendance = () => {
        handleGetAttendanceList();
        setIsOpenAttendance(true);
    }

    const materialModalOpen = () => {
        setMatDialog(true)
    }

    const materialModalClose = () => {
        setMatDialog(false)
    }

    const handleGetAssignmentPaths = async () => {
        try {
            const response = await getAssignmentPaths(programme, instructorcourse.split(" :")[0], instructorcourse.split(": ")[1] === instructorcourse.split(" :")[0] ? "" : instructorcourse.split(": ")[1], token)
            setAssignmentPaths(response.data)
            // setStartDate2(new Date(response.data.starDateTime));
        } catch (error) {
            console.error(error);
        }
    }

    const handleGetMaterialPaths = async () => {
        try {
            const response = await getMaterialPaths(programme, instructorcourse.split(" :")[0], instructorcourse.split(": ")[1] === instructorcourse.split(" :")[0] ? "" : instructorcourse.split(": ")[1], token)
            setMaterialPaths(response.data)
        } catch (error) {
            console.error(error);
        }
    }


    const handleAddAssignmentPath = async (path: any) => {

        const body = {
            programme: programme,
            stream: instructorcourse.split(" :")[0],
            subject: instructorcourse.split(": ")[1] === instructorcourse.split(" :")[0] ? null : instructorcourse.split(": ")[1],
            folder: newAssignmentFolderName,
            parentPath: path === "/Assignments" ? "" : path
        }

        try {
            const response = await addAssignmentFilePath(body, token)
            showAlert(response.data.message, "success")
        } catch (error: any) {
            showAlert(error.response.message, "error")
        }

        setNewAssignmentFolderName("");
        await handleGetAssignmentPaths();

    }

    const handleAddMaterialPath = async (path: any) => {

        const body = {
            programme: programme,
            stream: instructorcourse.split(" :")[0],
            subject: instructorcourse.split(": ")[1] === instructorcourse.split(" :")[0] ? null : instructorcourse.split(": ")[1],
            folder: newFolderName,
            parentPath: path === "/Materials" ? "" : path
        }

        try {
            const response = await addMaterialFilePath(body, token)
            showAlert(response.data.message, "success")
        } catch (error: any) {
            showAlert(error.response.message, "error")
        }

        setNewFolderName("");
        await handleGetMaterialPaths();

    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '75%',
        height: '80vh',
        bgcolor: 'grey',
        border: '2px solid white',
        boxShadow: 24,
        p: 4,
        borderRadius: '10px'
    };

    const toggleFolderAssignment = (path: string) => {
        setAssignmentExpandedPaths(prev => {
            const newSet = new Set(prev);
            if (newSet.has(path)) {
                newSet.delete(path);
            } else {
                newSet.add(path);
            }
            return newSet;
        });
    };

    const toggleFolder = (path: string) => {
        setExpandedPaths(prev => {
            const newSet = new Set(prev);
            if (newSet.has(path)) {
                newSet.delete(path);
            } else {
                newSet.add(path);
            }
            return newSet;
        });
    };

    const handleNavigateSubmissions = (materialAssignmentId: any, fName: any) => {
        navigate("/instructor/instructor-submissions", {
            state: {
                programme: programme,
                stream: instructorcourse.split(" :")[0],
                subject: instructorcourse.split(": ")[1] === instructorcourse.split(" :")[0] ? null : instructorcourse.split(": ")[1],
                materialAssignmentId: materialAssignmentId,
                fileName: fName
            }
        })
    };

    // Recursively render tree structure
    const renderAssignmentTree = (nodes: any[], parentPath = '') => {
        console.log(nodes);

        return nodes.map((node) => {
            const currentPath = parentPath ? `${parentPath}${node.filePath}` : node.filePath;
            const isFolder = node.children.length > 0 || node.materialAssignment.length > 0;
            const isExpanded = expandedAssignmentPaths.has(currentPath);

            return (
                <div key={node.id}>
                    <div
                        style={{ marginLeft: parentPath ? '20px' : '0px', position: 'relative', paddingRight: '40px' }}
                    >
                        <div
                            className="material-item"
                            style={{ cursor: 'pointer' }}
                            onClick={() => toggleFolderAssignment(currentPath)}
                        >
                            <i className="material-icon">
                                {isExpanded ? '📂' : '📁'}
                            </i>
                            <span>{node.filePath.split('/').pop()}</span>

                            <Button
                                onClick={() => handleAddClickAssignment(currentPath)} // Add Folder
                                variant="outlined"
                                size="small"
                                sx={{
                                    minWidth: '32px',
                                    padding: '4px',
                                    position: 'absolute',
                                    top: '4px',
                                    right: '70px',
                                    zIndex: 2,
                                    backgroundColor: '#f1c40f',
                                    border: 'none',
                                    color: '#000',
                                    '&:hover': {
                                        backgroundColor: '#d4ac0d',
                                        border: 'none',
                                    },
                                }}
                            >
                                <AddIcon fontSize="small" />
                            </Button>

                            <Button
                                onClick={() => handleAssignmentUploadClick(node.id)} // Upload File
                                variant="outlined"
                                size="small"
                                sx={{
                                    minWidth: '32px',
                                    padding: '4px',
                                    position: 'absolute',
                                    top: '4px',
                                    right: '35px',
                                    zIndex: 2,
                                    backgroundColor: '#2ecc71',
                                    border: 'none',
                                    color: '#fff',
                                    '&:hover': {
                                        backgroundColor: '#27ae60',
                                        border: 'none',
                                    },
                                }}
                            >
                                <Upload fontSize="small" />
                            </Button>

                            <Button
                                onClick={() => handleAssignmentDeleteClick(node.id)} // Delete Folder
                                variant="outlined"
                                size="small"
                                sx={{
                                    minWidth: '32px',
                                    padding: '4px',
                                    position: 'absolute',
                                    top: '4px',
                                    right: '0px',
                                    zIndex: 2,
                                    backgroundColor: '#e74c3c',
                                    border: 'none',
                                    color: '#fff',
                                    '&:hover': {
                                        backgroundColor: '#c0392b',
                                        border: 'none',
                                    },
                                }}
                            >
                                <DeleteIcon fontSize="small" />
                            </Button>

                        </div>

                        {isExpanded && (
                            <div>
                                {/* Render files (material) inside this folder */}
                                {node.materialAssignment.map((file: any) => (
                                    <div
                                        key={file.id}
                                        style={{
                                            marginLeft: '20px',
                                            position: 'relative',
                                            paddingRight: '40px',
                                        }}
                                    >
                                        <i className="material-icon">📄</i> <span>{file.fileName}</span>
                                        <span className={file.userUploadStatus === 1 ? "u-zone-label" : "u-zone-label2"}>
                                            {file.userUploadStatus === 1 ? `Upload zone enabled | Due : ${file.endDateTime?.split('T').join(' ')}` : "Upload zone disabled"}
                                        </span>
                                        <Button
                                            onClick={() => handleNavigateSubmissions(file.id, file.fileName)}
                                            variant="outlined"
                                            size="small"
                                            sx={{
                                                minWidth: '32px',
                                                padding: '4px 10px',
                                                zIndex: 2,
                                                backgroundColor: '#000000',
                                                margin: "10px 20px",
                                                border: 'none',
                                                color: '#fff',
                                                '&:hover': {
                                                    backgroundColor: '#000000',
                                                    border: 'none',
                                                },
                                            }}>
                                            Submissions
                                        </Button>
                                        {file.userUploadStatus === 2 ? (
                                            <Button
                                                onClick={() => handleUploadStatusClick(file.id)} // Call your delete file handler
                                                variant="outlined"
                                                size="small"
                                                sx={{
                                                    minWidth: '32px',
                                                    padding: '4px',
                                                    position: 'absolute',
                                                    top: '0px',
                                                    right: '0px',
                                                    zIndex: 2,
                                                    backgroundColor: '#000000',
                                                    border: 'none',
                                                    color: '#fff',
                                                    '&:hover': {
                                                        backgroundColor: '#000000',
                                                        border: 'none',
                                                    },
                                                }}
                                            >
                                                <FilePresent fontSize="small" />
                                            </Button>
                                        ) : (
                                            <Button
                                                onClick={() => handleUploadStatusClick2(file.id, file.startDateTime, file.endDateTime, file.attempts)} // Call your delete file handler
                                                variant="outlined"
                                                size="small"
                                                sx={{
                                                    minWidth: '32px',
                                                    padding: '4px',
                                                    position: 'absolute',
                                                    top: '0px',
                                                    right: '0px',
                                                    zIndex: 2,
                                                    backgroundColor: '#2ecc71',
                                                    border: 'none',
                                                    color: '#fff',
                                                    '&:hover': {
                                                        backgroundColor: '#27ae60',
                                                        border: 'none',
                                                    },
                                                }}
                                            >
                                                <FilePresent fontSize="small" />
                                            </Button>
                                        )}

                                        <Button
                                            onClick={() => handleDeleteAssignmentFileClick(file.id)} // Call your delete file handler
                                            variant="outlined"
                                            size="small"
                                            sx={{
                                                minWidth: '32px',
                                                padding: '4px',
                                                position: 'absolute',
                                                top: '0px',
                                                right: '35px',
                                                zIndex: 2,
                                                backgroundColor: '#e74c3c',
                                                border: 'none',
                                                color: '#fff',
                                                '&:hover': {
                                                    backgroundColor: '#c0392b',
                                                    border: 'none',
                                                },
                                            }}
                                        >
                                            <DeleteIcon fontSize="small" />
                                        </Button>
                                        <Button
                                            onClick={() => handleAssignmentViewClick(node.id, file.id)} // Call your delete file handler
                                            variant="outlined"
                                            size="small"
                                            sx={{
                                                minWidth: '32px',
                                                padding: '4px',
                                                position: 'absolute',
                                                top: '0px',
                                                right: '70px',
                                                zIndex: 2,
                                                backgroundColor: 'gray',
                                                border: 'none',
                                                color: '#fff',
                                                '&:hover': {
                                                    backgroundColor: 'black',
                                                    border: 'none',
                                                },
                                            }}
                                        >
                                            <Visibility fontSize="small" />
                                        </Button>
                                    </div>
                                ))}

                                {/* Recursively render subfolders */}
                                {renderAssignmentTree(node.children, currentPath)}
                            </div>
                        )}
                    </div>
                </div>
            );
        });
    };

    // Recursively render tree structure
    const renderMaterialTree = (nodes: any[], parentPath = '') => {
        return nodes.map((node) => {
            const currentPath = parentPath ? `${parentPath}${node.filePath}` : node.filePath;
            const isFolder = node.children.length > 0 || node.material.length > 0;
            const isExpanded = expandedPaths.has(currentPath);

            return (
                <div key={node.id}>
                    <div
                        style={{ marginLeft: parentPath ? '20px' : '0px', position: 'relative', paddingRight: '40px' }}
                    >
                        <div
                            className="material-item"
                            style={{ cursor: 'pointer' }}
                            onClick={() => toggleFolder(currentPath)}
                        >
                            <i className="material-icon">
                                {isExpanded ? '📂' : '📁'}
                            </i>
                            <span>{node.filePath.split('/').pop()}</span>

                            <Button
                                onClick={() => handleAddClickAssignment(currentPath)} // Add Folder
                                variant="outlined"
                                size="small"
                                sx={{
                                    minWidth: '32px',
                                    padding: '4px',
                                    position: 'absolute',
                                    top: '4px',
                                    right: '70px',
                                    zIndex: 2,
                                    backgroundColor: '#f1c40f',
                                    border: 'none',
                                    color: '#000',
                                    '&:hover': {
                                        backgroundColor: '#d4ac0d',
                                        border: 'none',
                                    },
                                }}
                            >
                                <AddIcon fontSize="small" />
                            </Button>

                            <Button
                                onClick={() => handleUploadClick(node.id)} // Upload File
                                variant="outlined"
                                size="small"
                                sx={{
                                    minWidth: '32px',
                                    padding: '4px',
                                    position: 'absolute',
                                    top: '4px',
                                    right: '35px',
                                    zIndex: 2,
                                    backgroundColor: '#2ecc71',
                                    border: 'none',
                                    color: '#fff',
                                    '&:hover': {
                                        backgroundColor: '#27ae60',
                                        border: 'none',
                                    },
                                }}
                            >
                                <Upload fontSize="small" />
                            </Button>

                            <Button
                                onClick={() => handleDeleteClick(node.id)} // Delete Folder
                                variant="outlined"
                                size="small"
                                sx={{
                                    minWidth: '32px',
                                    padding: '4px',
                                    position: 'absolute',
                                    top: '4px',
                                    right: '0px',
                                    zIndex: 2,
                                    backgroundColor: '#e74c3c',
                                    border: 'none',
                                    color: '#fff',
                                    '&:hover': {
                                        backgroundColor: '#c0392b',
                                        border: 'none',
                                    },
                                }}
                            >
                                <DeleteIcon fontSize="small" />
                            </Button>

                        </div>

                        {isExpanded && (
                            <div>
                                {/* Render files (material) inside this folder */}
                                {node.material.map((file: any) => (
                                    <div
                                        key={file.id}
                                        style={{
                                            marginLeft: '20px',
                                            position: 'relative',
                                            paddingRight: '40px',
                                        }}
                                    >
                                        <i className="material-icon">📄</i> <span>{file.fileName}</span>
                                        <Button
                                            onClick={() => handleDeleteFileClick(file.id)} // Call your delete file handler
                                            variant="outlined"
                                            size="small"
                                            sx={{
                                                minWidth: '32px',
                                                padding: '4px',
                                                position: 'absolute',
                                                top: '0px',
                                                right: '0px',
                                                zIndex: 2,
                                                backgroundColor: '#e74c3c',
                                                border: 'none',
                                                color: '#fff',
                                                '&:hover': {
                                                    backgroundColor: '#c0392b',
                                                    border: 'none',
                                                },
                                            }}
                                        >
                                            <DeleteIcon fontSize="small" />
                                        </Button>
                                        <Button
                                            onClick={() => handleViewClick(node.id, file.id)} // Call your delete file handler
                                            variant="outlined"
                                            size="small"
                                            sx={{
                                                minWidth: '32px',
                                                padding: '4px',
                                                position: 'absolute',
                                                top: '0px',
                                                right: '35px',
                                                zIndex: 2,
                                                backgroundColor: 'gray',
                                                border: 'none',
                                                color: '#fff',
                                                '&:hover': {
                                                    backgroundColor: 'black',
                                                    border: 'none',
                                                },
                                            }}
                                        >
                                            <Visibility fontSize="small" />
                                        </Button>
                                    </div>
                                ))}

                                {/* Recursively render subfolders */}
                                {renderMaterialTree(node.children, currentPath)}
                            </div>
                        )}
                    </div>
                </div>
            );
        });
    };

    const handleAssignmentUploadClick = (folderId: any) => {
        setUploadAssignmentFolderId(folderId);
        setUploadAssignmentModalOpen(true);
    };

    const handleUploadClick = (folderId: any) => {
        setUploadFolderId(folderId);
        setUploadModalOpen(true);
    };

    const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        const files = e.dataTransfer.files;
        if (files && files.length > 0) {
            const file = files[0];
            const isPdf = file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf");
            if (!isPdf) {
                showAlert("Only PDF files are allowed", "warning");
                setDragActive(false);
                return;
            }
            // place into correct state depending on which modal is open
            if (uploadAssignmentModalOpen) {
                setSelectedAssignmentFile([file]);
            } else {
                setSelectedFile([file]);
            }
        }
        setDragActive(false);
    };


    const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(true);
    };

    const handleDragLeave = () => {
        setDragActive(false);
    };

    const handleUploadAssignment = async () => {
        setUploadAssignmentModalOpen(false)
        setLoading(true);
        const formData = new FormData();
        formData.append("FilePathId", uploadAssignmentFolderId);
        formData.append("File", selectedAssignmentFile[0]);
        formData.append("Description", "")

        try {
            const response = await addAssignment(formData, token)
            showAlert(response.data.message, "success")

        } catch (error: any) {
            showAlert(error.response.message, "error")
        }

        setLoading(false);
        setSelectedAssignmentFile(null);
        await handleGetAssignmentPaths();
    }

    const handleUpload = async () => {
        setUploadModalOpen(false)
        setLoading(true);
        const formData = new FormData();
        formData.append("FilePathId", uploadFolderId);
        formData.append("File", selectedFile[0]);

        try {
            const response = await addMaterial(formData, token)
            showAlert(response.data.message, "success")

        } catch (error: any) {
            showAlert(error.response.message, "error")
        }

        setLoading(false);
        setSelectedFile(null);
        await handleGetMaterialPaths();
    }

    const handleAssignmentDeleteClick = (folderId: any) => {
        setUploadAssignmentFolderId(folderId);
        setIsOpenA1(true)
    };

    const handleDeleteClick = (folderId: any) => {
        setUploadFolderId(folderId);
        setIsOpen1(true)
    };

    const handleAssignmentViewClick = async (nodeId: any, folderId: any) => {
        setLoading(true);
        try {
            const response = await getAssignment(folderId, nodeId, token);
            const base64 = response.data.file;
            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);

            setPdfUrlA(blobUrl); // Save it in state and show in an iframe/modal
            setLoading(false);

        } catch (error) {
            console.error(error);
        }
    };

    const handleViewClick = async (nodeId: any, folderId: any) => {
        setLoading(true);
        try {
            const response = await getMaterial(folderId, nodeId, token);
            const base64 = response.data.file;
            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);

            setPdfUrl(blobUrl); // Save it in state and show in an iframe/modal
            setLoading(false);

        } catch (error) {
            console.error(error);
        }
    };

    const handleDeleteAssignmentPath = async () => {
        try {
            const response = await deleteAssignmentFilePath(uploadAssignmentFolderId, token)
            showAlert(response.data.message, "success")
        } catch (error: any) {
            showAlert(error.response.message, "error")
        }

        await handleGetAssignmentPaths();
        setIsOpenA1(false);
    }

    const handleDeletePath = async () => {
        try {
            const response = await deleteMaterialFilePath(uploadFolderId, token)
            showAlert(response.data.message, "success")
        } catch (error: any) {
            showAlert(error.response.message, "error")
        }

        await handleGetMaterialPaths();
        setIsOpen1(false);
    }

    const getLastUniquePath = (path: string): string => {
        console.log(path);

        const parts = path.split('/').filter(Boolean);
        const seen = new Set<string>();
        const result: string[] = [];

        for (let i = parts.length - 1; i >= 0; i--) {
            const part = parts[i];
            if (!seen.has(part)) {
                result.unshift(part);
                seen.add(part);
            } else {
                break; // Stop at first duplicate from the end
            }
        }

        return '/' + result.join('/');
    };

    const handleUploadStatusModalClose = () => {
        setUploadStatusVisibility(false)
        setUploadAssignmentFolderId(undefined);
        setStartDate(new Date());
        setEndDate(new Date());
        setAttempts(0);
    }

    const handleUploadStatusModalClose2 = () => {
        setUploadStatusVisibility2(false)
        setUploadAssignmentFolderId(undefined);
        setStartDate2(new Date());
        setEndDate2(new Date());
        setAttempts2(0);
    }

    const handleUploadStatusClick = async (fileId: number) => {
        setStartDate(new Date());
        setEndDate(new Date());
        setAttempts(0);
        setUploadAssignmentFolderId(fileId);
        setUploadStatusVisibility(true)
    };

    const handleUploadStatusClick2 = async (fileId: number, start: any, end: any, attempts: number) => {
        setStartDate2(new Date(start));
        setEndDate2(new Date(end));
        setAttempts2(attempts)
        setUploadAssignmentFolderId(fileId);
        setUploadStatusVisibility2(true)
    };

    const handleDeleteAssignmentFileClick = async (fileId: number) => {
        setUploadAssignmentFolderId(fileId);
        setIsOpenA2(true)
    };

    const handleDeleteFileClick = async (fileId: number) => {
        setUploadFolderId(fileId);
        setIsOpen2(true)
    };

    const handleDeleteAssignment = async () => {
        try {
            const response = await deleteAssignment(uploadAssignmentFolderId, token)
            showAlert(response.data.message, "success")
        } catch (error: any) {
            showAlert(error.response.message, "error")
        }

        await handleGetAssignmentPaths();
        setIsOpenA2(false);
    }

    const handleDelete = async () => {
        try {
            const response = await deleteMaterial(uploadFolderId, token)
            showAlert(response.data.message, "success")
        } catch (error: any) {
            showAlert(error.response.message, "error")
        }

        await handleGetMaterialPaths();
        setIsOpen2(false);
    }

    const formatDateTimeToDotNet = (date: Date): string => {
        const pad = (num: number, size: number) => num.toString().padStart(size, '0');

        return `${date.getFullYear()}-${pad(date.getMonth() + 1, 2)}-${pad(date.getDate(), 2)}T` +
            `${pad(date.getHours(), 2)}:${pad(date.getMinutes(), 2)}:${pad(date.getSeconds(), 2)}.` +
            `${pad(date.getMilliseconds(), 3)}000`;
    };


    const handleEnable = async (start: any, end: any, attempts: number) => {
        if (start?.getTime() === end?.getTime()) {
            showAlert("Start date time and end date time is same", "error");
            return;
        }

        if (start?.getTime() > end?.getTime()) {
            showAlert("Start date time must be less than end date time", "error");
            return;
        }

        const formattedStart = formatDateTimeToDotNet(start!);
        const formattedEnd = formatDateTimeToDotNet(end!);

        console.log('Formatted Start:', formattedStart);
        console.log('Formatted End:', formattedEnd);

        const body = {
            programme: programme,
            stream: instructorcourse.split(" :")[0],
            subject: instructorcourse.split(": ")[1] === instructorcourse.split(" :")[0] ? null : instructorcourse.split(": ")[1],
            id: uploadAssignmentFolderId,
            status: 1,
            attempts: attempts,
            startDate: formattedStart,
            endDate: formattedEnd
        }

        try {
            const res = await updateUploadStatus(body, token)
            showAlert("Upload Zone Enabled.", "success")
        } catch (error: any) {
            showAlert(error.response.message, "error")
        }

        handleUploadStatusModalClose();

        await handleGetAssignmentPaths();
    };

    const handleDisable = async (start: any, end: any) => {

        const formattedStart = formatDateTimeToDotNet(start!);
        const formattedEnd = formatDateTimeToDotNet(end!);

        console.log('Formatted Start:', formattedStart);
        console.log('Formatted End:', formattedEnd);

        const body = {
            programme: programme,
            stream: instructorcourse.split(" :")[0],
            subject: instructorcourse.split(": ")[1] === instructorcourse.split(" :")[0] ? null : instructorcourse.split(": ")[1],
            id: uploadAssignmentFolderId,
            status: 2,
            startDate: formattedStart,
            endDate: formattedEnd
        }

        try {
            const res = await updateUploadStatus(body, token)
            showAlert("Upload Zone Disabled", "success")
        } catch (error: any) {
            showAlert(error.response.message, "error")
        }

        handleUploadStatusModalClose();

        await handleGetAssignmentPaths();
    };

    return (
        <div className="comman-outer" >
            <Spinner isLoading={loading} />

            <Modal
                open={Boolean(pdfUrl)}
                onClose={() => setPdfUrl(null)}
                sx={{ zIndex: 20000 }}
                slots={{ backdrop: undefined }}
            >
                <Box
                    sx={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        bgcolor: "rgba(0,0,0,0.9)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <IconButton
                        onClick={() => setPdfUrl(null)}
                        sx={{
                            position: "absolute",
                            top: 16,
                            right: 16,
                            color: "white",
                            bgcolor: "rgba(0,0,0,0.4)",
                            '&:hover': { bgcolor: "rgba(0,0,0,0.6)" },
                            zIndex: 20001,
                        }}
                    >
                        <Close />
                    </IconButton>

                    {pdfUrl && (
                        <Box
                            component="iframe"
                            src={pdfUrl}
                            sx={{ width: "100%", height: "100%", border: "none" }}
                        />
                    )}
                </Box>
            </Modal>

            <Modal
                open={Boolean(pdfUrlA)}
                onClose={() => setPdfUrlA(null)}
                sx={{ zIndex: 20000 }}
                slots={{ backdrop: undefined }}
            >
                <Box
                    sx={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        bgcolor: "rgba(0,0,0,0.9)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <IconButton
                        onClick={() => setPdfUrlA(null)}
                        sx={{
                            position: "absolute",
                            top: 16,
                            right: 16,
                            color: "white",
                            bgcolor: "rgba(0,0,0,0.4)",
                            '&:hover': { bgcolor: "rgba(0,0,0,0.6)" },
                            zIndex: 20001,
                        }}
                    >
                        <Close />
                    </IconButton>

                    {pdfUrlA && (
                        <Box
                            component="iframe"
                            src={pdfUrlA}
                            sx={{ width: "100%", height: "100%", border: "none" }}
                        />
                    )}
                </Box>
            </Modal>

            <Dialogbox
                open={isOpenA1}
                title="Delete Confirmation"
                content="Are you sure? Do you want to delete this?"
                agreeButtonText="Yes, Delete"
                disagreeButtonText="No"
                onAgree={handleDeleteAssignmentPath}
                onDisagree={handleCloseA1}
                onClose={handleCloseA1}
            />

            <Dialogbox
                open={isOpen1}
                title="Delete Confirmation"
                content="Are you sure? Do you want to delete this?"
                agreeButtonText="Yes, Delete"
                disagreeButtonText="No"
                onAgree={handleDeletePath}
                onDisagree={handleClose1}
                onClose={handleClose1}
            />
            <Dialogbox
                open={isOpenA2}
                title="Delete Confirmation"
                content="Are you sure? Do you want to delete this?"
                agreeButtonText="Yes, Delete"
                disagreeButtonText="No"
                onAgree={handleDeleteAssignment}
                onDisagree={handleCloseA2}
                onClose={handleCloseA2}
            />
            <Dialogbox
                open={isOpen2}
                title="Delete Confirmation"
                content="Are you sure? Do you want to delete this?"
                agreeButtonText="Yes, Delete"
                disagreeButtonText="No"
                onAgree={handleDelete}
                onDisagree={handleClose2}
                onClose={handleClose2}
            />

            <Modal
                open={addAssignmentFolderModalOpen}
                onClose={() => setAddAssignmentFolderModalOpen(false)}
                aria-labelledby="add-folder-modal-title"
                aria-describedby="add-folder-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: '#1e1e1e', // Dark background
                    color: '#ffffff',    // Light text
                    border: '1px solid #444',
                    boxShadow: 24,
                    p: 1,
                    borderRadius: 2
                }}>
                    {/* <Typography variant="body2" sx={{ m: 1, color: '#ccc' }}>
                        Create Folder : <strong>{selectedFolderPath}/{newFolderName}</strong>
                    </Typography> */}

                    <PrimaryInputField
                        placeholder="Enter Folder Name"
                        helperText="Folder Name"
                        value={newAssignmentFolderName}
                        type="text"
                        disabled={false}
                        width="95%"
                        size='small'
                        onChange={(e) => setNewAssignmentFolderName(e.target.value)}
                    />

                    <Box display="flex" justifyContent="flex-end" gap={2} mt={3}>
                        <Button variant="outlined" onClick={() => setAddAssignmentFolderModalOpen(false)} sx={{
                            color: '#fff',
                            borderColor: '#555',
                            '&:hover': {
                                borderColor: '#888'
                            }
                        }}>
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            onClick={() => {
                                const trimmedPath = getLastUniquePath(selectedAssignmentFolderPath);
                                setAddAssignmentFolderModalOpen(false);
                                setNewAssignmentFolderName("");
                                handleAddAssignmentPath(trimmedPath); // send shortened path
                            }}
                            disabled={!newAssignmentFolderName}
                            sx={{
                                backgroundColor: 'grey',
                                color: '#000',
                                '&:hover': {
                                    backgroundColor: '#e0e0e0',
                                },
                                '&.Mui-disabled': {
                                    backgroundColor: '#555',
                                    color: '#ccc',
                                    opacity: 0.5,
                                    cursor: 'not-allowed',
                                },
                            }}
                        >
                            Save
                        </Button>
                    </Box>
                </Box>
            </Modal>

            <Modal
                open={addFolderModalOpen}
                onClose={() => setAddFolderModalOpen(false)}
                aria-labelledby="add-folder-modal-title"
                aria-describedby="add-folder-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: '#1e1e1e', // Dark background
                    color: '#ffffff',    // Light text
                    border: '1px solid #444',
                    boxShadow: 24,
                    p: 1,
                    borderRadius: 2
                }}>
                    {/* <Typography variant="body2" sx={{ m: 1, color: '#ccc' }}>
                        Create Folder : <strong>{selectedFolderPath}/{newFolderName}</strong>
                    </Typography> */}

                    <PrimaryInputField
                        placeholder="Enter Folder Name"
                        helperText="Folder Name"
                        value={newFolderName}
                        type="text"
                        disabled={false}
                        width="95%"
                        size='small'
                        onChange={(e) => setNewFolderName(e.target.value)}
                    />

                    <Box display="flex" justifyContent="flex-end" gap={2} mt={3}>
                        <Button variant="outlined" onClick={() => setAddFolderModalOpen(false)} sx={{
                            color: '#fff',
                            borderColor: '#555',
                            '&:hover': {
                                borderColor: '#888'
                            }
                        }}>
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            onClick={() => {
                                const trimmedPath = getLastUniquePath(selectedFolderPath);
                                setAddFolderModalOpen(false);
                                setNewFolderName("");
                                handleAddMaterialPath(trimmedPath); // send shortened path
                            }}
                            disabled={!newFolderName}
                            sx={{
                                backgroundColor: 'grey',
                                color: '#000',
                                '&:hover': {
                                    backgroundColor: '#e0e0e0',
                                },
                                '&.Mui-disabled': {
                                    backgroundColor: '#555',
                                    color: '#ccc',
                                    opacity: 0.5,
                                    cursor: 'not-allowed',
                                },
                            }}
                        >
                            Save
                        </Button>
                    </Box>
                </Box>
            </Modal>

            <Modal
                open={uploadStatusVisibility}
                onClose={handleUploadStatusModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{ ...style, maxWidth: "80%", width: "550px", height: "auto", p: 4, position: 'relative', backgroundColor: "black" }}>
                    <IconButton
                        onClick={handleUploadStatusModalClose}
                        sx={{ position: 'absolute', top: 8, right: 8, color: 'grey' }}
                    >
                        <CloseCircleFilled />
                    </IconButton>

                    <Typography id="modal-modal-title" variant="h5" component="h6" sx={{ fontWeight: 'bold', mb: 2, color: "white", fontSize: "16px" }}>
                        Do you want to enable upload zone for this Assignment?
                    </Typography>

                    <FormLabel sx={{ fontWeight: 'bold', mb: 1, color: "white" }}>Allowed Attempts</FormLabel>
                    <TextField
                        type="number"
                        value={attempts}
                        onChange={(e) => setAttempts(Number(e.target.value))}
                        onFocus={(e) => e.target.select()}
                        fullWidth
                        size="small"
                        inputProps={{ min: 1 }}
                        sx={{
                            backgroundColor: '#ffffff',
                            '& .MuiInputBase-input': {
                                color: '#000000',
                            },
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: '#ccc',
                                },
                            },
                        }}
                    />
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Stack spacing={2}>
                            <FormLabel sx={{ fontWeight: 'bold', mb: 1, color: "white" }}>Start Date & Time</FormLabel>
                            <DateTimePicker
                                value={startDate}
                                onChange={setStartDate}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        size="small"
                                        sx={{
                                            backgroundColor: '#ffffff',
                                            '& .MuiInputBase-input': {
                                                color: '#000000', // optional: change text color
                                            },
                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                    borderColor: '#ccc', // optional: border color
                                                },
                                            },
                                        }}
                                    />
                                )}
                            />

                            <FormLabel sx={{ fontWeight: 'bold', mb: 1, color: "white" }}>End Date & Time</FormLabel>
                            <DateTimePicker
                                value={endDate}
                                onChange={setEndDate}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        size="small"
                                        sx={{
                                            backgroundColor: '#ffffff',
                                            '& .MuiInputBase-input': {
                                                color: '#000000',
                                            },
                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                    borderColor: '#ccc',
                                                },
                                            },
                                        }}
                                    />
                                )}
                            />

                            <Button className='primary-btn' variant="contained" color="primary" onClick={(e) => handleEnable(startDate, endDate, attempts)}>
                                Enable
                            </Button>
                        </Stack>
                    </LocalizationProvider>
                </Box>
            </Modal>

            <Modal
                open={uploadStatusVisibility2}
                onClose={handleUploadStatusModalClose2}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{ ...style, maxWidth: "80%", width: "550px", height: "auto", p: 4, position: 'relative', backgroundColor: "black" }}>
                    <IconButton
                        onClick={handleUploadStatusModalClose2}
                        sx={{ position: 'absolute', top: 8, right: 8, color: 'grey' }}
                    >
                        <CloseCircleFilled />
                    </IconButton>

                    <Typography id="modal-modal-title" variant="h5" component="h6" sx={{ fontWeight: 'bold', mb: 2, color: "white", fontSize: "16px" }}>
                        Do you want to change upload zone visibility?
                    </Typography>

                    <FormLabel sx={{ fontWeight: 'bold', mb: 1, color: "white" }}>Allowed Attempts</FormLabel>
                    <TextField
                        type="number"
                        value={attempts2}
                        onChange={(e) => setAttempts2(Number(e.target.value))}
                        onFocus={(e) => e.target.select()}
                        fullWidth
                        size="small"
                        inputProps={{ min: 1 }}
                        sx={{
                            backgroundColor: '#ffffff',
                            '& .MuiInputBase-input': {
                                color: '#000000',
                            },
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: '#ccc',
                                },
                            },
                        }}
                    />


                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Stack spacing={2}>
                            <FormLabel sx={{ fontWeight: 'bold', mb: 1, color: "white" }}>Start Date & Time</FormLabel>
                            <DateTimePicker
                                value={startDate2}
                                onChange={setStartDate2}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        size="small"
                                        sx={{
                                            backgroundColor: '#ffffff',
                                            '& .MuiInputBase-input': {
                                                color: '#000000', // optional: change text color
                                            },
                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                    borderColor: '#ccc', // optional: border color
                                                },
                                            },
                                        }}
                                    />
                                )}
                            />

                            <FormLabel sx={{ fontWeight: 'bold', mb: 1, color: "white" }}>End Date & Time</FormLabel>
                            <DateTimePicker
                                value={endDate2}
                                onChange={setEndDate2}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        size="small"
                                        sx={{
                                            backgroundColor: '#ffffff',
                                            '& .MuiInputBase-input': {
                                                color: '#000000',
                                            },
                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                    borderColor: '#ccc',
                                                },
                                            },
                                        }}
                                    />
                                )}
                            />

                            <Box display="flex" justifyContent="flex-end" gap={2} mt={3}>
                                <Button variant="contained" color="error" onClick={(e) => handleDisable(startDate2, endDate2)}>
                                    Disable
                                </Button>
                                <Button className="primary-btn" variant="contained" color="primary" onClick={(e) => handleEnable(startDate2, endDate2, attempts2)}>
                                    Update Duration
                                </Button>
                            </Box>

                        </Stack>
                    </LocalizationProvider>
                </Box>
            </Modal>

            {
                uploadModalOpen && (
                    <div className="upload-modal-backdrop">
                        <div className="upload-modal">
                            <h2>Upload Files</h2>
                            <div
                                className={`drop-zone ${dragActive ? 'active' : ''}`}
                                onDrop={handleDrop}
                                onDragOver={handleDragOver}
                                onDragLeave={handleDragLeave}
                            >
                                {selectedFile && selectedFile.length > 0 ? (
                                    <p className="file-list">{selectedFile[0].name}</p>
                                ) : (
                                    <p>Drag & drop a file here or click to browse</p>
                                )}


                                <input
                                    type="file"
                                    multiple
                                    onChange={(e) => setSelectedFile(e.target.files)}
                                />
                            </div>
                            <div className="upload-actions">
                                <button className="btn cancel" onClick={() => {
                                    setUploadModalOpen(false)
                                    setSelectedFile(null)
                                }}>Cancel</button>
                                <button
                                    className="btn upload"
                                    disabled={!selectedFile}
                                    onClick={handleUpload}
                                >
                                    Upload
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }

            {
                uploadAssignmentModalOpen && (
                    <div className="upload-modal-backdrop">
                        <div className="upload-modal">
                            <h2>Upload Files</h2>
                            <div
                                className={`drop-zone ${dragActive ? 'active' : ''}`}
                                onDrop={handleDrop}
                                onDragOver={handleDragOver}
                                onDragLeave={handleDragLeave}
                            >
                                {selectedAssignmentFile && selectedAssignmentFile.length > 0 ? (
                                    <p className="file-list">{selectedAssignmentFile[0].name}</p>
                                ) : (
                                    <p>Drag & drop a file here or click to browse</p>
                                )}


                                <input
                                    type="file"
                                    multiple
                                    onChange={(e) => setSelectedAssignmentFile(e.target.files)}
                                    accept='application/pdf'
                                />
                            </div>
                            <div className="upload-actions">
                                <button className="btn cancel" onClick={() => {
                                    setUploadAssignmentModalOpen(false)
                                    setSelectedAssignmentFile(null)
                                }}>Cancel</button>
                                <button
                                    className="btn upload"
                                    disabled={!selectedAssignmentFile}
                                    onClick={handleUploadAssignment}
                                >
                                    Upload
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }

            <div className="comman-header-outer">
                <span className="stream-title-text" tabIndex={-1} ref={streamTitleRef}>
                    {course}
                </span>

                {resInsId && (
                    <div>
                        <Button
                            className="primary-btn mr"
                            variant="contained"
                            onClick={handleOpenAttendance}
                            startIcon={
                                <Tooltip title="This Class Attendance List" arrow>
                                    <OrderedListOutlined className="add-icon" />
                                </Tooltip>
                            }
                        >
                            Attendance List
                        </Button>

                        <Button
                            className="error-btn mr"
                            variant="contained"
                            onClick={handleOpenDialog2}
                            startIcon={
                                <Tooltip title="End Zoom Invitation" arrow>
                                    <Close className="close-icon" />
                                </Tooltip>
                            }
                        >
                            {text.subjects.endClass}
                        </Button>
                    </div>

                )}

                {resLink && (
                    <div>
                        <Button
                            className="primary-btn"
                            variant="contained"
                            onClick={handleOpenDialog}
                            startIcon={
                                <Tooltip title="Create Zoom Invitiation" arrow>
                                    <AddIcon className="add-icon" />
                                </Tooltip>
                            }
                        >
                            {text.subjects.createClass}
                        </Button>
                    </div>

                )}
                <CustomAlert
                    open={alertOpen}
                    onClose={() => setAlertOpen(false)}
                    description={alertDescription}
                    type={alertType}
                    timeout={3000}
                />
                <Dialogbox
                    open={isOpen}
                    title={text.delete.deleteText}
                    content={text.delete.deleteConfirmation}
                    agreeButtonText={text.delete.delete}
                    disagreeButtonText={text.delete.cancel}
                    onAgree={handleDeleteRecording}
                    onDisagree={handleClose}
                    onClose={handleClose}
                />

                <Dialogbox
                    open={isOpenEnd}
                    title={text.end.title}
                    content={text.end.confirmation}
                    agreeButtonText={text.end.end}
                    disagreeButtonText={text.end.cancel}
                    onAgree={handleDeleteMeeting}
                    onDisagree={handleCloseEnd}
                    onClose={handleCloseEnd}
                />

                <Dialog
                    open={isOpenAttendance}
                    onClose={() => setIsOpenAttendance(false)}
                    sx={{
                        "& .MuiPaper-root": {
                            border: "2px solid #333",
                            backgroundColor: "#575757ff",
                            color: "#fff",
                            width: "95%",
                        },
                    }}
                >
                        <DialogTitle
                            sx={{
                                fontSize: "1.2rem",
                                color: "#fff",
                                textAlign: "center",
                                fontWeight: "bold",
                            }}
                        >
                            Attendance List
                        </DialogTitle>

                        {/* 🔍 Search Bar */}
                        <Box sx={{ px: 2, mb: 1 }}>
                            <input
                                type="text"
                                placeholder="Search student..."
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                style={{
                                    width: "100%",
                                    padding: "10px 14px",
                                    borderRadius: "6px",
                                    border: "1px solid #555",
                                    background: "#2a2a2a",
                                    color: "white",
                                    fontSize: "0.9rem",
                                    outline: "none",
                                }}
                            />
                        </Box>

                        {/* Scrollable List */}
                        <Box
                            sx={{
                                maxHeight: "90vh",
                                overflowY: "auto",
                                px: 2,
                                pb: 2,
                            }}
                        >
                            {attendanceList
                                ?.filter((item) =>
                                    item.fullName.toLowerCase().includes(searchText.toLowerCase())
                                )
                                .map((item, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            background: "#2a2a2a",
                                            borderRadius: "10px",
                                            padding: "12px",
                                            mb: 1.5,
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }}
                                    >
                                        {/* Student Name */}
                                        <Typography sx={{ fontSize: "0.95rem", fontWeight: 600 }}>
                                            {item.fullName}
                                        </Typography>

                                        {/* Attendance Dropdown */}
                                        <Select
                                            value={item.isAttend ? "present" : "absent"}
                                            onChange={(e) => {
                                                handleAttendanceChange(
                                                    item.userId,
                                                    e.target.value === "present"
                                                );
                                                handleMarkAttendance(
                                                    item,
                                                    e.target.value === "present"
                                                );
                                            }}
                                            size="small"
                                            sx={{
                                                width: "140px",
                                                background: "#1e1e1e",
                                                color: "#fff",
                                                borderRadius: "6px",
                                                "& .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: "grey",
                                                },
                                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: "#aaa",
                                                },
                                            }}
                                        >
                                            <MenuItem value="present">Present</MenuItem>
                                            <MenuItem value="absent">Absent</MenuItem>
                                        </Select>
                                    </Box>
                                ))}
                        </Box>
                </Dialog>


                <Dialog open={openDialog} onClose={handleCloseDialog} sx={{
                    "& .MuiPaper-root": {
                        border: "2px solid #333",
                        backgroundColor: "#1e1e1e",
                        color: "#fff",
                    },
                }}>
                    <div className="center">
                        <img style={{ width: '120px', marginTop: '20px' }} src={zoom} alt="" />
                    </div>
                    <DialogContent style={{ textAlign: "center" }} dividers>
                        <PrimaryInputField
                            placeholder="Enter Invite Link"
                            helperText="Zoom Invite Link"
                            value={inviteLink}
                            type="text"
                            disabled={false}
                            width="95%"
                            size='small'
                            onChange={(e: any) => setInviteLink(e.target.value)}
                        />

                        <PrimaryInputField
                            placeholder="Enter Duration"
                            helperText="Duration (hours)"
                            value={duration}
                            type="number"
                            disabled={false}
                            width="95%"
                            size='small'
                            onChange={(e: any) => setDuration(Number(e.target.value))}
                            onFocus={(e) => e.target.select()}
                        />
                        <Typography variant="caption" sx={{ color: 'grey', textAlign: 'center', display: 'block', mt: 1 }}>
                            *The Zoom invitation will automatically expire after the specified duration.
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDialog}
                            sx={{
                                color: 'grey',
                                '&:hover': {
                                    border: '#e0e0e0',
                                },
                            }}>Cancel</Button>
                        <Button
                            variant="contained"
                            onClick={handleSaveInvitiation}
                            disabled={!inviteLink || !duration || duration === 0}
                            sx={{
                                backgroundColor: 'grey',
                                color: '#000',
                                '&:hover': {
                                    backgroundColor: '#e0e0e0',
                                },
                                '&.Mui-disabled': {
                                    backgroundColor: '#555',
                                    color: '#ccc',
                                    opacity: 0.5,
                                    cursor: 'not-allowed',
                                },
                            }}
                        >
                            Start
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={openRecordingDialog}
                    onClose={handleCloseRecordingDialog}
                    sx={{
                        "& .MuiPaper-root": {
                            border: "2px solid #333",
                            backgroundColor: "#1e1e1e",
                            color: "#fff",
                        },
                    }}
                >
                    <div className="center">
                        <img className='d-img' src={addRecording} alt="Zoom" />
                    </div>
                    <DialogTitle sx={{ fontSize: '1rem', color: 'grey', fontWeight: 'bold', textAlign: 'center' }}>
                        Add Zoom Recording or Video for Students
                    </DialogTitle>
                    <DialogContent style={{ textAlign: "center" }} dividers>
                        <PrimaryInputField
                            placeholder="Enter Title"
                            helperText="Recording Title"
                            value={recordingTitle}
                            type="text"
                            disabled={false}
                            width="95%"
                            size='small'
                            onChange={(e: any) => setRecordingTitle(e.target.value)}
                        />

                        <PrimaryInputField
                            placeholder="Enter URL"
                            helperText="Recording URL"
                            value={recordingLink}
                            type="text"
                            disabled={false}
                            width="95%"
                            size='small'
                            onChange={(e: any) => setRecordingLink(e.target.value)}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseRecordingDialog}
                            sx={{
                                color: 'grey',
                                '&:hover': {
                                    border: '#e0e0e0',
                                },
                            }}>Cancel</Button>
                        <Button
                            variant="contained"
                            onClick={handleSaveRecording}
                            disabled={!recordingTitle || !recordingLink}
                            sx={{
                                backgroundColor: 'grey',
                                color: '#000',
                                '&:hover': {
                                    backgroundColor: '#e0e0e0',
                                },
                                '&.Mui-disabled': {
                                    backgroundColor: '#555',
                                    color: '#ccc',
                                    opacity: 0.5,
                                    cursor: 'not-allowed',
                                },
                            }}
                        >
                            Add
                        </Button>
                    </DialogActions>
                </Dialog>

                {/*<Button
                    className="primary-btn mr outlined"
                    variant="contained"
                    onClick={handleOpenDialog}
                    startIcon={
                        <Tooltip title="Zoom class in progress" arrow>
                            <span className="recording-wrapper">
                                <FiberManualRecordIcon className="recording-icon" />
                            </span>
                        </Tooltip>
                    }
                >
                    {text.subjects.joinClass}
                </Button>*/}
            </div>

            <div className="subject-main-outer">
                <div className="subject-main-inner1 full-width">

                    {/* Learning Materials Card */}
                    <div className="subject-content">
                        {/* <div className="learning-card">
                                <div className="card-top" style={{ position: 'relative' }}>
                                    <div
                                        onClick={toggleExpand}
                                        style={{ display: 'flex', flex: 1, alignItems: 'center', cursor: 'pointer' }}
                                    >
                                        <img src={learning} alt="Learning Materials" className="card-thumb" />
                                        <div className="card-info" style={{ marginLeft: '8px' }}>
                                            <h3>{text.subjects.learningMaterials}</h3>
                                            <p>{text.subjects.learningMaterialsDesc}</p>
                                        </div>
                                        <div className="card-progress" style={{ marginLeft: 'auto', paddingRight: '8px' }}>
                                            <span>{isExpanded ? "▲" : "▼"}</span>
                                        </div>
                                    </div>
                                    <Button
                                        onClick={() => handleAddClick("Materials")}
                                        variant="outlined"
                                        size="small"
                                        sx={{
                                            minWidth: '32px',
                                            padding: '4px',
                                            position: 'absolute',
                                            top: '8px',
                                            right: '8px',
                                            zIndex: 2,
                                            backgroundColor: '#f1c40f',
                                            border: 'none',
                                            color: '#000',
                                            '&:hover': {
                                                backgroundColor: '#d4ac0d',
                                                border: 'none',
                                            },
                                        }}
                                    >
                                        <AddIcon fontSize="small" />
                                    </Button>
                                </div>

                                {isExpanded && (
                                    <div className="card-body">
                                        {renderMaterialTree(materialPaths)}
                                    </div>
                                )}
                            </div> */}
                    </div>


                    {/* Assignments Card */}
                    <div className="subject-content">
                        <div className="learning-card">
                            <div className="card-top" style={{ position: 'relative' }}>
                                <div onClick={toggleExpand1} style={{ display: 'flex', flex: 1, alignItems: 'center', cursor: 'pointer' }}>
                                    <img src={assignments} alt="Assignments" className="card-thumb" />
                                    <div className="card-info" style={{ marginLeft: '8px' }}>
                                        <h3>{text.subjects.assignments}</h3>
                                        <p>{text.subjects.assignmentsDesc}</p>
                                    </div>
                                    <div className="card-progress">
                                        <span>{isExpanded1 ? "▲" : "▼"}</span>
                                    </div>
                                </div>
                                <Button
                                    onClick={() => handleAddClickAssignment("Assignments")}
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                        minWidth: '32px',
                                        padding: '4px',
                                        position: 'absolute',
                                        top: '8px',
                                        right: '8px',
                                        zIndex: 2,
                                        backgroundColor: '#f1c40f',
                                        border: 'none',
                                        color: '#000',
                                        '&:hover': {
                                            backgroundColor: '#d4ac0d',
                                            border: 'none',
                                        },
                                    }}
                                >
                                    <AddIcon fontSize="small" />
                                </Button>
                            </div>

                            {isExpanded1 && (
                                <div className="card-body">
                                    {renderAssignmentTree(assignmentPaths)}
                                </div>
                            )}

                            {/* {isExpanded1 && (
                                <div className="card-body">
                                    {materials.map((item, idx) => (
                                        <div className="material-item" key={idx}>
                                            <i className="material-icon">📄</i>
                                            <span>{item}</span>
                                        </div>
                                    ))}
                                </div>
                            )} */}
                        </div>
                    </div>

                    {/* Recordings Card */}
                    <div className="subject-content">
                        <div className="learning-card">
                            <div className="card-top" style={{ position: 'relative' }}>
                                <div onClick={toggleExpand2} style={{ display: 'flex', flex: 1, alignItems: 'center', cursor: 'pointer' }}>
                                    <img src={recordings} alt="Recordings" className="card-thumb" />
                                    <div className="card-info" style={{ marginLeft: '8px' }}>
                                        <h3>{text.subjects.zoomRecordings}</h3>
                                        <p>{text.subjects.zoomRecordingsDesc}</p>
                                    </div>
                                    <div className="card-progress">
                                        <span>{isExpanded2 ? "▲" : "▼"}</span>
                                    </div>
                                </div>
                                <Button
                                    onClick={handleOpenRecordingDialog}
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                        minWidth: '32px',
                                        padding: '4px',
                                        position: 'absolute',
                                        top: '8px',
                                        right: '8px',
                                        zIndex: 2,
                                        backgroundColor: '#f1c40f',
                                        border: 'none',
                                        color: '#000',
                                        '&:hover': {
                                            backgroundColor: '#d4ac0d',
                                            border: 'none',
                                        },
                                    }}
                                >
                                    <AddIcon fontSize="small" />
                                </Button>
                            </div>

                            {isExpanded2 && (
                                <div className="card-body">
                                    {recordingsLinks.length === 0 ? (
                                        <div className="material-item">
                                            <i className="material-icon">📄</i>
                                            <span>No Content Available</span>
                                        </div>
                                    ) : (
                                        recordingsLinks.map((recording, idx) => (
                                            <div className="material-item" key={idx} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <img style={{ width: "25px" }} src={camera} alt="" />
                                                    <span
                                                        onClick={() =>
                                                            navigate("/instructor/instructor-recording", {
                                                                state: { link: recording.recordLink, title: recording.title || `Recording ${idx + 1}` },
                                                            })
                                                        }
                                                        style={{ color: 'white', cursor: 'pointer', textDecoration: 'underline' }}
                                                    >
                                                        {recording.title || `Recording ${idx + 1}`}
                                                    </span>
                                                </div>

                                                <div>
                                                    {/* Toggle Visibility */}
                                                    {!recording.activeStatus && (
                                                        <Tooltip title="Set as Visible">
                                                            <IconButton onClick={(e) => handleVisibility(true, recording.id)}>
                                                                <VisibilityIcon style={{ color: "white" }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    )}

                                                    {recording.activeStatus && (
                                                        <Tooltip title="Set as Invisible">
                                                            <IconButton onClick={(e) => handleVisibility(false, recording.id)}>
                                                                <VisibilityOffIcon style={{ color: "white" }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    )}

                                                    {/* Delete */}
                                                    <Tooltip title="Delete">
                                                        <IconButton onClick={(e) => handleOpen(recording.id)}>
                                                            <DeleteIcon style={{ color: "#e74c3c" }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </div>
                                            </div>

                                        ))
                                    )}
                                </div>
                            )}

                        </div>
                    </div>

                </div>
            </div>
        </div >
    );
};
